import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const StyledTitle = styled.h4`
  font: ${theme.font.h4};
  color: ${(props) => props.theme.black};
  font-family: inherit;
  `;

export const StyledLink = styled.a`
  color: ${(props) => props.theme.orangeLink};
`;

export const StyledButton = styled.button`
  display: block;
  margin: ${theme.margin.x4} auto 0;
`;
